import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';

const Temoignages = () => {
  const [temoignages, setTemoignages] = useState([]);
  const [index, setIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const Url = process.env.REACT_APP_URL_DEV;
  const intervalRef = useRef(null);

  useEffect(() => {
    const fetchTemoignages = async () => {
      try {
        const response = await axios.get(`${Url}/api/temoignages/all`);
        setTemoignages(response.data.data);
      } catch (error) {
        console.error('Erreur lors de la récupération des témoignages:', error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTemoignages();
  }, [Url]);

  useEffect(() => {
    if (temoignages.length > 0) {
      intervalRef.current = setInterval(() => {
        setIndex((prevIndex) =>
          prevIndex === temoignages.length - 1 ? 0 : prevIndex + 1,
        );
      }, 5000);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [temoignages.length]);

  const resetInterval = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setIndex((prevIndex) =>
        prevIndex === temoignages.length - 1 ? 0 : prevIndex + 1,
      );
    }, 5000);
  };

  const prevTestimonial = () => {
    setIndex((prevIndex) =>
      prevIndex === 0 ? temoignages.length - 1 : prevIndex - 1,
    );
    resetInterval();
  };

  const nextTestimonial = () => {
    setIndex((prevIndex) =>
      prevIndex === temoignages.length - 1 ? 0 : prevIndex + 1,
    );
    resetInterval();
  };

  const removeHtmlTags = (html) => {
    if (!html) return ' ';
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || ' ';
  };

  if (loading)
    return <p className="text-center py-8">Chargement des témoignages...</p>;
  if (error)
    return <p className="text-center py-8 text-red-500">Erreur: {error}</p>;
  if (temoignages.length === 0)
    return <p className="text-center py-8">Aucun témoignage disponible.</p>;

  const currentTemoignage = temoignages[index] || {};
  const imageUrl = currentTemoignage.temoignagesImage
    ? `${Url}/images/${currentTemoignage.temoignagesImage}`
    : 'https://via.placeholder.com/200';

  return (
    <div className="testimonial-section bg-gray-50 py-10 px-4 max-w-3xl mx-auto">
      <h2 className="text-3xl font-bold mb-8 text-center text-gray-800">
        Témoignages
      </h2>

      {/* Container flex horizontal */}
      <div className="flex flex-col md:flex-row items-center md:justify-center md:space-x-6">
        {/* Témoignage */}
        <div className="carousel-slide bg-white shadow-lg p-6 rounded-xl max-w-xl w-full">
          <div className="flex justify-center mb-6">
            <div className="w-36 h-36 rounded-full overflow-hidden border-4 border-gray-300">
              <img
                key={currentTemoignage.id || index} // ✅ force React à recréer l’image
                src={imageUrl}
                alt={currentTemoignage.Nom || 'Témoignage'}
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.target.onerror = null; // ✅ évite boucle infinie
                  e.target.src = 'https://via.placeholder.com/200';
                }}
              />
            </div>
          </div>

          <h3 className="text-xl font-semibold text-gray-700">
            {currentTemoignage.Nom || 'Nom inconnu'}
          </h3>
          <p className="text-sm text-gray-500 mb-4">
            {currentTemoignage.temoignagesPost || 'Poste inconnu'}
          </p>
          <div className="testimonial-text text-gray-600">
            <p>{removeHtmlTags(currentTemoignage.temoignagesDescription)}</p>
          </div>
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '1rem',
          marginBottom: '1.5rem',
          marginRight: '0',
          '@media (min-width: 768px)': {
            marginBottom: '0',
            marginRight: '1.5rem',
          },
        }}
      >
        <button
          onClick={prevTestimonial}
          aria-label="Précédent"
          style={{
            padding: '0.4rem',
            borderRadius: '50%',
            backgroundColor: 'transparent',
            transition: 'all 0.3s ease',
            border: '2px solid transparent',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            style={{
              height: '1.25rem',
              width: '1.25rem',
              color: '#fdc800',
            }}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1.5}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>

        <button
          onClick={nextTestimonial}
          aria-label="Suivant"
          style={{
            padding: '0.4rem', // ✅ cercle plus petit
            borderRadius: '50%',
            backgroundColor: 'transparent', // ✅ transparent
            transition: 'all 0.3s ease',
            border: '2px solid transparent', // ✅ contour bleu foncé
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            style={{
              height: '1.25rem', // ✅ flèche plus petite
              width: '1.25rem',
              color: '#fdc800',
            }}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1.5}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Temoignages;
